import {
    debounce,
    isEmpty,
    trimPipes,
    removeDuplicates,
    sanitize,
    easeOutExpo,
    isDesktop,
    convertToClass,
} from "../../_js/common/_util";

import mCustomScrollbar from "mCustomScrollbar";

import MaterialDesign from "../../_js/common/_material-design.js";
import Company from "../company/company";
import { googleSheets } from "../../_js/common/_variables";
import DataListCard from "../data-list-card/data-list-card";

("use strict");

export default class Filter {
    constructor() {
        // this.isInit = false;
    }

    init(map, model) {
        // if (this.isInit) {
        //     return false;
        // }

        const self = this;

        let htmlMarkUp = "";
        let value = "";

        self.map = map;
        self.model = model;
        self.company = new Company();
        self.material = new MaterialDesign();

        self.$filterBtnCountry = $(".filter__button.-country span");
        self.$filterBtnCompany = $(".filter__button.-company span");
        self.$filterBtnTypeOfCompany = $(
            ".filter__button.-type-of-company span"
        );
        self.$filterBtnOwnership = $(".filter__button.-ownership span");
        self.$filterBtnOverseasPresence = $(
            ".filter__button.-overseasPresence span"
        );
        self.$filterBtnTopics = $(".filter__button.-topics span");
        self.$filterMsg = $(".filter .filter__msg");

        self.$dataResultsFilters = $(".data-results-filters");
        self.dataResultsFiltersArray = [];

        self.companyArray = [];
        self.countries = [];
        self.regions = [];
        self.overseasPresence = [];
        self.topics = [];
        self.companies = [];
        self.ownership = [];
        self.typeOfCompany = [];

        self.selectedCompany = [];
        self.selectedCountry = [];
        self.selectedType = [];
        self.selectedOwnership = [];
        self.selectedOverseasPresence = [];
        self.selectedTopics = [];
        self.paramsLength = [];

        self.selectedFilter = [];

        // * Company - 1
        self.model.companyModel.forEach((el, i) => {
            if (i > 0 && !isEmpty(el[1]) && !isEmpty(el[3])) {
                // * Type of company
                self.typeOfCompany.push(trimPipes(el[1]));

                // * Company name
                self.companies.push(el[3]);
            }

            // * Ownership structure
            if (
                i > 0 &&
                !isEmpty(el[1]) &&
                !isEmpty(el[2]) &&
                !isEmpty(el[3])
            ) {
                self.ownership.push(trimPipes(el[2]));
            }
        });

        self.typeOfCompany = removeDuplicates(self.typeOfCompany).sort();
        self.ownership = removeDuplicates(self.ownership).sort();
        self.companies = removeDuplicates(self.companies).sort();

        self.companies.forEach((el, i) => {
            self.companyArray.push({
                name: el,
                paramsLength: [],
                filter: {
                    country: false,
                    typeOfCompany: false,
                    ownership: false,
                    // * 'areasOfBusiness': false,
                    overseasPresence: false,
                },
            });
        });

        // * Overseas Presence - 3
        self.model.overseasPresenceModel.forEach((el, i) => {
            if (i > 0 && !isEmpty(el[1]) && !isEmpty(trimPipes(el[2]))) {
                // self.countries.push(trimPipes(el[3]));
                self.overseasPresence.push(trimPipes(el[2]));
            }

            if (i > 0 && !isEmpty(el[1]) && !isEmpty(trimPipes(el[11]))) {
                self.topics.push(trimPipes(el[11]));
            }

            if (i > 0 && !isEmpty(el[1]) && !isEmpty(trimPipes(el[12]))) {
                self.topics.push(trimPipes(el[12]));
            }

            if (i > 0 && !isEmpty(el[1]) && !isEmpty(trimPipes(el[13]))) {
                self.topics.push(trimPipes(el[13]));
            }
        });

        self.model.countriesModel.forEach((el, i) => {
            if (
                i > 0 &&
                !isEmpty(el[1]) &&
                !isEmpty(trimPipes(el[2])) &&
                !isEmpty(el[3]) &&
                !isEmpty(el[4])
            ) {
                self.countries.push({
                    name: el[1],
                    region: trimPipes(el[4]),
                });
            }
        });

        // * Create array of regions with blank countries
        self.model.regionsModel.forEach((el, i) => {
            if (i > 0) {
                self.regions.push({
                    name: el[1],
                    countries: [],
                });
            }
        });

        // * slot in the countries to the respective regions
        self.regions.forEach((el, i) => {
            self.countries.forEach((em, j) => {
                if (el.name == em.region) {
                    el.countries.push(em.name);
                }
            });
        });

        // * self.countries = removeDuplicates(self.countries).sort();
        self.overseasPresence = removeDuplicates(self.overseasPresence).sort();
        self.topics = removeDuplicates(self.topics).sort();

        // * Set up the filters checkboxes and autocomplete
        // * Append Country
        let regionName = "";
        let regionVal = "";
        let countryName = "";
        let countryVal = "";
        htmlMarkUp = '<ul class="filter__region">';

        self.regions.forEach((el, i) => {
            regionName = el.name;
            regionVal = sanitize(regionName);
            htmlMarkUp += `<li class="form-item -checkbox -${regionVal}">
                                <input id="${
                                    regionVal + "-region"
                                }" type="checkbox" name="region" value="f1-${regionName}" tabindex="1" />
                                <label for="${
                                    regionVal + "-region"
                                }"><span>${regionName}</span></label>`;

            if (el.countries.length > 0) {
                htmlMarkUp += `<ul class="filter__country">`;

                el.countries.forEach((em, j) => {
                    countryName = em;
                    countryVal = sanitize(countryName);
                    htmlMarkUp += `<li class="form-item -checkbox -${countryVal}">
                                        <input id="${
                                            convertToClass(countryVal) + "-country"
                                        }" type="checkbox" name="country" value="f1-${countryName}" tabindex="1"/>
                                        <label for="${
                                            convertToClass(countryVal) + "-country"
                                        }"><span>${countryName}</span></label>
                                    </li>`;
                });

                htmlMarkUp += `</ul>`;
            }

            htmlMarkUp += `</li>`;
        });

        htmlMarkUp += "<ul>";

        $(".filter__selection.-country .filter__scroll").append(htmlMarkUp);

        // * Append Company
        if (self.companies.length > 0) {
            htmlMarkUp = "<ul>";
            self.companies.forEach((el, i) => {
                value = sanitize(el);

                htmlMarkUp += `<li class="form-item -checkbox -${value}">
                                    <input id="${
                                        convertToClass(value) + "-company"
                                    }" type="checkbox" name="company" value="f2-${el}" tabindex="1"/>
                                    <label for="${
                                        convertToClass(value) + "-company"
                                    }"><span>${el}</span></label>
                                </li>`;
            });
            htmlMarkUp += "</ul>";
            $(".filter__selection.-company .filter__scroll").append(htmlMarkUp);
        }

        // * Append Type of Company
        if (self.typeOfCompany.length > 0) {
            htmlMarkUp = "<ul>";
            self.typeOfCompany.forEach((el, i) => {
                value = sanitize(el);

                htmlMarkUp += `<li class="form-item -checkbox -${value}">
                                    <input id="${
                                        value + "-type"
                                    }" type="checkbox" name="typeOfCompany" value="f3-${el}" tabindex="1"/>
                                    <label for="${
                                        value + "-type"
                                    }"><span>${el}</span></label>
                                </li>`;
            });
            htmlMarkUp += "</ul>";
            $(".filter__selection.-type-of-company .filter__scroll").append(
                htmlMarkUp
            );
        }

        // * Append Ownership Structure
        if (self.ownership.length > 0) {
            htmlMarkUp = "<ul>";
            self.ownership.forEach((el, i) => {
                value = sanitize(el);

                htmlMarkUp += `<li class="form-item -checkbox -${value}">
                                    <input id="${
                                        value + "-ownership"
                                    }" type="checkbox" name="ownership" value="f4-${el}" tabindex="1"/>
                                    <label for="${
                                        value + "-ownership"
                                    }"><span>${el}</span></label>
                                </li>`;
            });
            htmlMarkUp += "</ul>";
            $(".filter__selection.-ownership .filter__scroll").append(
                htmlMarkUp
            );
        }

        // * Append Overseas Presence
        if (self.overseasPresence.length > 0) {
            htmlMarkUp = "<ul>";
            self.overseasPresence.forEach((el, i) => {
                value = sanitize(el);

                htmlMarkUp += `<li class="form-item -checkbox -${convertToClass(
                    value
                )}">
                                    <input id="${convertToClass(
                                        value
                                    )}" type="checkbox" name="overseasPresence" value="f5-${el}" tabindex="1"/>
                                    <label for="${convertToClass(
                                        value
                                    )}"><span>${el}</span></label>
                                </li>`;
            });
            htmlMarkUp += "</ul>";
            $(".filter__selection.-overseasPresence .filter__scroll").append(
                htmlMarkUp
            );
        }

        // * Append Topic
        if (self.topics.length > 0) {
            htmlMarkUp = "     <ul>";
            self.topics.forEach((el, i) => {
                value = sanitize(el);

                htmlMarkUp += `     <li class="form-item -checkbox -${value}">
                                        <input id="${value}" type="checkbox" name="topics" value="f6-${el}" tabindex="1"/>
                                        <label for="${value}"><span>${el}</span></label>
                                    </li>`;
            });
            htmlMarkUp += "</ul>";
            $(".filter__selection.-topics .filter__scroll").append(htmlMarkUp);
        }

        $(".filter__scroll").mCustomScrollbar({
            theme: "dark-thin",
            advanced: {
                updateOnContentResize: true,
            },
        });

        // * Init Listeners only when successfully loaded
        // const $jsToggleFilter = $(".-js-toggle-filter");

        // self.$filterSelection = $(".filter__selection");
        self.$filterInput = $('.filter__selection input[type="text"]');
        self.$filterCheckbox = $('.filter__selection input[type="checkbox"]');

        // $jsToggleFilter.on("click", function (e) {
        //     e.preventDefault();

        //     $(".filter__buttons .-filter").toggleClass("-expand");
        //     $(".explore-map").toggleClass("-expand");
        //     $(".toaster__wrap").toggleClass("-expand");

        //     if (isDesktop()) {
        //         self.$filterSelection.slideToggle(easeOutExpo);
        //         self.$filterMsg.slideToggle(easeOutExpo);
        //     } else {
        //         $(".filter__buttons > li:nth-child(n + 2)").slideToggle(
        //             easeOutExpo
        //         );
        //     }
        // });

        $(".-js-toggle-buttons").on("click", function (e) {
            e.preventDefault();

            const $this = $(this);
            const $filter__buttons = $this.closest(".filter__buttons");
            $filter__buttons.find(".expanded").removeClass("expanded");

            $(".-js-toggle-buttons").next().clearQueue().slideUp(easeOutExpo);

            $this
                .addClass("expanded")
                .next()
                .stop()
                .clearQueue()
                .slideToggle(easeOutExpo);
        });

        $(".-js-reset-filter").on("click", function (e) {
            e.preventDefault();

            self.resetFilter();

            if (window.location.hash.indexOf("home") > -1) {
                history.pushState(null, null, "/#/companies/");
            } else if (window.location.hash.indexOf("map") > -1) {
                // self.map.displayAllMarkers();
                history.pushState(null, null, "/#/map/");
            }

            self.material.toaster("Filter has been reset.");
        });

        $('.filter__region > li input[type="checkbox"]').on(
            "change",
            debounce(function () {
                const $this = $(this);
                const $nestedCheckbox = $(this)
                    .parent()
                    .find('.filter__country input[type="checkbox"]');

                $nestedCheckbox.prop("checked", $this.is(":checked"));
            }, 500)
        );

        self.$filterInput.on(
            "keyup",
            debounce(function () {
                $(this)
                    .parent()
                    .find(".form-item.-checkbox")
                    .hide()
                    .each((i, v) => {
                        const $this = $(v);
                        if (
                            $this
                                .attr("class")
                                .indexOf(this.value.toLowerCase()) > -1
                        ) {
                            $this.show().parent().parent().show();
                        }
                    });
            }, 500)
        );

        self.$filterCheckbox.on(
            "change",
            debounce(function () {
                self.selectedFilter = [];
                self.processFilter();
            }, 750)
        );

        $(".form-item.-toggle").on(
            "change",
            debounce(function () {
                self.selectedFilter = [];
                self.processFilter();
            }, 750)
        );

        // this.isInit = true;
    }

    toggleFilters(data, overseasPresenceModel) {
        $(".-checkbox").addClass("-disabled");

        let countryListArr = [];

        overseasPresenceModel.forEach((el) => {
            data.forEach((em) => {
                if (em.c[0] !== null && el[0] == em.c[0].f) {
                    if (!isEmpty(trimPipes(el[4]))) {
                        $(
                            `#${sanitize(
                                convertToClass(trimPipes(el[4]))
                            )}-country`
                        )
                            .parent()
                            .removeClass("-disabled")
                            .parent()
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (em.c[2] !== null && !isEmpty(em.c[2].v)) {
                        let countryArr = em.c[2].v.split(",");
                        countryArr.forEach((val, ind) => {
                            countryListArr.push(convertToClass(trimPipes(val)));
                        });
                    }

                    if (!isEmpty(trimPipes(el[1]))) {
                        $(
                            `#${sanitize(
                                convertToClass(trimPipes(el[1]))
                            )}-company`
                        )
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[19]))) {
                        $(
                            `#${sanitize(
                                convertToClass(trimPipes(el[19]))
                            )}-type`
                        )
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[20]))) {
                        $(
                            `#${sanitize(
                                convertToClass(trimPipes(el[20]))
                            )}-ownership`
                        )
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[2]))) {
                        $(`#${sanitize(convertToClass(trimPipes(el[2])))}`)
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[3]))) {
                        $(`#${sanitize(convertToClass(trimPipes(el[3])))}`)
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[10]))) {
                        $(`#${sanitize(convertToClass(trimPipes(el[10])))}`)
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[11]))) {
                        $(`#${sanitize(convertToClass(trimPipes(el[11])))}`)
                            .parent()
                            .removeClass("-disabled");
                    }

                    if (!isEmpty(trimPipes(el[21]))) {
                        el[21].split(",").forEach((en) => {
                            $(`#${sanitize(convertToClass(en))}-country`)
                                .parent()
                                .removeClass("-disabled");
                        });
                    }
                }
            });
        });

        countryListArr = removeDuplicates(countryListArr);
        countryListArr.forEach((val, ind) => {
            $(`#${val}-country`)
                .parent()
                .removeClass("-disabled")
                .parent()
                .parent()
                .removeClass("-disabled");
        });
    }

    checkFilterColumns() {
        const self = this;

        if (self.dataResultsFiltersArray.length >= 1) {
            let dataResultsFiltersHtml = "";

            // group filters when over 5 items
            if (self.dataResultsFiltersArray.length > 4) {
                dataResultsFiltersHtml +=
                    `<div class="filter-all-btn-wrap"><div class="filter-btn filter-all-btn">Filter (<span class="filter-all-count">` +
                    self.dataResultsFiltersArray.length +
                    `</span>)<span class="clear-all-btn">Clear all</span></div><div class="filter-all-close-btn"></div>`;
                dataResultsFiltersHtml += `<div class="invisible-buttons">`;
            }

            self.dataResultsFiltersArray.forEach((item, index) => {
                dataResultsFiltersHtml += `<button class="filter-btn ${convertToClass(
                    sanitize(item)
                )}-btn">${item}</button>`;
            });

            // group filters when over 5 items
            if (self.dataResultsFiltersArray.length > 4) {
                dataResultsFiltersHtml += `</div></div>`;
            }

            $(".data-results-filters").html(dataResultsFiltersHtml);

            $(`.filter-btn`).each(function () {
                let btnClass = $(this).attr("class").split(/\s+/)[1];
                $("." + btnClass)
                    .unbind("click")
                    .click(function () {
                        $(".-" + btnClass.substring(0, btnClass.length - 4))
                            .find("input")
                            .first()
                            .trigger("click");
                    });
            });

            $(`.filter-all-btn`).click(function () {
                $(`.filter-all-btn-wrap`).addClass(
                    `filter-all-btn-wrap-expanded`
                );
            });
            $(`.filter-all-close-btn`).click(function () {
                $(`.filter-all-btn-wrap`).removeClass(
                    `filter-all-btn-wrap-expanded`
                );
            });
            $(`.clear-all-btn`).click(function () {
                $(`.invisible-buttons`)
                    .children()
                    .each(function () {
                        $(this).click();
                    });
            });

            if ($(".filter .data-results-wrap .filter-btn").length < 5) {
                $(".data-results-wrap").removeClass("-enabled");
                $(".data-results-wrap").removeClass("-floating");
            } else {
                $(".data-results-wrap").addClass("-enabled");
                $(".filters-expand-btn span").html(
                    " (" +
                        $(".filter .data-results-wrap .filter-btn").length +
                        ")"
                );
            }
        } else {
            $(".data-results-filters").html("");
            $(".data-results-wrap").removeClass("-enabled");
            $(".data-results-wrap").removeClass("-floating");
        }

        // * Displays what filters are selected
        if (self.selectedCountry.length > 0) {
            self.paramsLength.push(1);

            if (self.selectedCountry.length == 1) {
                self.$filterBtnCountry.text(self.selectedCountry[0]);
            } else {
                self.$filterBtnCountry.text(
                    self.selectedCountry[0] +
                        " +(" +
                        (self.selectedCountry.length - 1) +
                        ")"
                );
            }
        } else {
            self.$filterBtnCountry.text("");
        }

        if (self.selectedCompany.length > 0) {
            self.paramsLength.push(1);

            if (self.selectedCompany.length == 1) {
                self.$filterBtnCompany.text(self.selectedCompany[0]);
            } else {
                self.$filterBtnCompany.text(
                    self.selectedCompany[0] +
                        " +(" +
                        (self.selectedCompany.length - 1) +
                        ")"
                );
            }

            if (window.location.hash.indexOf("home") > -1) {
                self.disableOthers();
            }
        } else {
            // * if (window.location.hash.indexOf('home') > -1) {
            // *     self.enableOthers();
            // * }

            self.$filterBtnCompany.text("");
        }

        if (self.selectedType.length > 0) {
            self.paramsLength.push(1);

            if (self.selectedType.length == 1) {
                self.$filterBtnTypeOfCompany.text(self.selectedType[0]);
            } else {
                self.$filterBtnTypeOfCompany.text(
                    self.selectedType[0] +
                        " +(" +
                        (self.selectedType.length - 1) +
                        ")"
                );
            }
        } else {
            self.$filterBtnTypeOfCompany.text("");
        }

        if (self.selectedOwnership.length > 0) {
            self.paramsLength.push(1);

            if (self.selectedOwnership.length == 1) {
                self.$filterBtnOwnership.text(self.selectedOwnership[0]);
            } else {
                self.$filterBtnOwnership.text(
                    self.selectedOwnership[0] +
                        " +(" +
                        (self.selectedOwnership.length - 1) +
                        ")"
                );
            }
        } else {
            self.$filterBtnOwnership.text("");
        }

        if (self.selectedOverseasPresence.length > 0) {
            self.paramsLength.push(1);

            if (self.selectedOverseasPresence.length == 1) {
                self.$filterBtnOverseasPresence.text(
                    self.selectedOverseasPresence[0]
                );
            } else {
                self.$filterBtnOverseasPresence.text(
                    self.selectedOverseasPresence[0] +
                        " +(" +
                        (self.selectedOverseasPresence.length - 1) +
                        ")"
                );
            }
        } else {
            self.$filterBtnOverseasPresence.text("");
        }

        if (self.selectedTopics.length > 0) {
            self.paramsLength.push(1);

            if (self.selectedTopics.length == 1) {
                self.$filterBtnTopics.text(self.selectedTopics[0]);
            } else {
                self.$filterBtnTopics.text(
                    self.selectedTopics[0] +
                        " +(" +
                        (self.selectedTopics.length - 1) +
                        ")"
                );
            }
        } else {
            self.$filterBtnTopics.text("");
        }

        // * Enable/disable Company column if Country is selected
        if (
            self.selectedCountry.length > 0 ||
            self.selectedType.length > 0 ||
            self.selectedOwnership.length > 0 ||
            self.selectedOverseasPresence.length > 0 ||
            self.selectedTopics.length > 0
        ) {
            if (window.location.hash.indexOf("home") > -1) {
                self.disableCompany();
            }
        } else {
            if (window.location.hash.indexOf("home") > -1) {
                self.enableCompany();
            }
        }

        // * Identify which companies is present
        if (window.location.hash.indexOf("data") > -1) {
            // * Filtering on Homepage
            self.model.overseasPresenceModel.forEach((el) => {
                self.selectedCountry.forEach((em) => {
                    // * If country_id == selected country in filter
                    if (trimPipes(el[4]) == em) {
                        $.each(self.companyArray, (i, v) => {
                            if (v.name == trimPipes(el[1])) {
                                v.filter.country = true;
                                self.selectedObjects.country.push(v.name);

                                return false;
                            }
                        });
                        return false;
                    }
                });

                self.selectedOverseasPresence.forEach((em) => {
                    // * if infrastructure_type_id == selected overseas presence in filter
                    if (trimPipes(el[2]) == em) {
                        $.each(self.companyArray, (i, v) => {
                            if (v.name == trimPipes(el[1])) {
                                v.filter.overseasPresence = true;
                                self.selectedObjects.overseasPresence.push(
                                    v.name
                                );

                                return false;
                            }
                        });
                        return false;
                    }
                });
            });

            self.model.companyModel.forEach((el) => {
                self.selectedType.forEach((em) => {
                    if (trimPipes(el[1]) == em) {
                        $.each(self.companyArray, (i, v) => {
                            if (v.name == el[3]) {
                                v.filter.typeOfCompany = true;
                                self.selectedObjects.typeOfCompany.push(v.name);

                                return false;
                            }
                        });
                        return false;
                    }
                });

                self.selectedOwnership.forEach((em) => {
                    if (trimPipes(el[2]) == em) {
                        $.each(self.companyArray, (i, v) => {
                            if (v.name == el[3]) {
                                v.filter.ownership = true;
                                self.selectedObjects.ownership.push(v.name);

                                return false;
                            }
                        });
                        return false;
                    }
                });

                self.selectedCompany.forEach((em) => {
                    if (el[3] == em) {
                        $.each(self.companyArray, (i, v) => {
                            if (v.name == el[3]) {
                                v.filter.ownership = true;
                                self.selectedObjects.company.push(v.name);

                                return false;
                            }
                        });
                        return false;
                    }
                });
            });

            // * Remove duplicates (for sanitation)
            if (self.selectedObjects !== undefined) {
                self.selectedObjects.country = removeDuplicates(
                    self.selectedObjects.country
                );
                self.selectedObjects.overseasPresence = removeDuplicates(
                    self.selectedObjects.overseasPresence
                );
                self.selectedObjects.typeOfCompany = removeDuplicates(
                    self.selectedObjects.typeOfCompany
                );
                self.selectedObjects.ownership = removeDuplicates(
                    self.selectedObjects.ownership
                );
                // * self.selectedObjects.areasOfBusiness = removeDuplicates(self.selectedObjects.areasOfBusiness);

                // * Determine which company should be visible
                self.companyArray.forEach((el, i) => {
                    if (self.paramsLength == 1) {
                        // * show the one filter applicable
                        if (
                            el.filter.country ||
                            el.filter.typeOfCompany ||
                            el.filter.ownership ||
                            // * el.filter.areasOfBusiness ||
                            el.filter.overseasPresence
                        ) {
                            self.displayCompanies.push(el.name);
                        }
                    } else {
                        // * show multiple filters applicable
                        if (
                            self.selectedObjects.country.indexOf(
                                el.name.toString()
                            ) > -1 &&
                            el.filter.country == true
                        ) {
                            el.paramsLength.push(1);
                        }

                        if (
                            self.selectedObjects.typeOfCompany.indexOf(
                                el.name.toString()
                            ) > -1 &&
                            el.filter.typeOfCompany == true
                        ) {
                            el.paramsLength.push(1);
                        }

                        if (
                            self.selectedObjects.ownership.indexOf(
                                el.name.toString()
                            ) > -1 &&
                            el.filter.ownership == true
                        ) {
                            el.paramsLength.push(1);
                        }

                        if (
                            self.selectedObjects.overseasPresence.indexOf(
                                el.name.toString()
                            ) > -1 &&
                            el.filter.overseasPresence == true
                        ) {
                            el.paramsLength.push(1);
                        }
                    }

                    if (el.paramsLength.length == self.paramsLength.length) {
                        self.displayCompanies.push(el.name);
                    }
                });

                let html = "";
                const dataListCard = new DataListCard();

                const query = self.map.createQueryString(
                    self.selectedFilter,
                    true
                );

                // https://docs.google.com/spreadsheets/d/e/${googleSheets.urlID}/pubhtml
                let _url = `https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:json&gid=1003963993&tq=${query}`;
                let _linkURL = `https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:csv&gid=1003963993&tq=${query}`;

                $(".download-results-btn").attr("href", _linkURL);

                $(".data-list-page__content__body__content").html("");

                TweenLite.to(".view-loader", 1, {
                    autoAlpha: 1,
                    scale: 1,
                    ease: Expo.easeOut,
                });

                $.ajax({
                    url: _url,
                    success: function (res) {
                        TweenLite.to(".view-loader", 1, {
                            autoAlpha: 0,
                            scale: 0.25,
                            ease: Expo.easeOut,
                        });

                        let data = res;

                        data = data.replace("/*O_o*/", "");
                        data = data.replace(
                            "google.visualization.Query.setResponse(",
                            ""
                        );
                        data = data.substring(0, data.length - 2);

                        data = JSON.parse(data);

                        if (data.table.rows.length == 0) {
                            $(".data-list-page__content__body__content").html(
                                `<p class="error-message">There are no results found.  Try a different search query.</p>`
                            );
                            self.displayResultNumber(0);
                            $(".data-results-number").text(0);
                            self.material.toaster(
                                "There are no results found.  Try a different search query."
                            );
                            return false;
                        }

                        data = data.table.rows;

                        let dataPointCount = 0;
                        for (var key in data) {
                            let newArray = [];
                            for (var key2 in data[key].c) {
                                newArray[key2] =
                                    data[key].c[key2] === null
                                        ? ""
                                        : data[key].c[key2].v;
                            }

                            if (!isEmpty(newArray[2])) {
                                dataPointCount += 1;
                                html +=
                                    dataListCard.generateDataListCardHTML(
                                        newArray
                                    );
                            }
                        }

                        $(".data-list-page__content__body__content").html(html);
                        $(".data-results-number").text(dataPointCount);

                        self.toggleFilters(
                            data,
                            self.model.overseasPresenceModel
                        );
                    },
                    error: function (err) {
                        console.error(err);
                    },
                });
            }
        } else if (window.location.hash.indexOf("map") > -1) {
            self.map.filterMap(self.selectedFilter);

            if (self.selectedFilter.length == 0) {
                history.pushState(null, null, "/#/map/");
                self.$filterMsg.html("");
            } else {
                history.pushState(
                    null,
                    null,
                    "/#/map/" + encodeURI(self.selectedFilter)
                );
            }
        } else if (window.location.hash.indexOf("company") > -1) {
            self.map.filterMap(self.selectedFilter);
            // history.pushState(null, null, '/#/map/' + encodeURI(self.selectedFilter));
        }
    }

    displayResultNumber(num) {
        const self = this;
        let filterMessage = "";
        let numResults = num;

        if (numResults == 1) {
            filterMessage =
                "<p>There is <strong><em>" +
                numResults +
                "</em></strong> filtered result.</p>";
        } else if (numResults > 1) {
            filterMessage =
                "<p>There are <strong><em>" +
                numResults +
                "</em></strong> filtered results.</p>";
        } else {
            filterMessage =
                "<p>There are <strong><em>" +
                numResults +
                "</em></strong> filtered results.</p>";
        }

        self.$filterMsg.html(filterMessage);
    }

    setFilter(param) {
        const self = this;

        if (param == undefined) {
            return false;
        }

        let arr = param.split(",");

        // * Check selected checkboxed
        $.each($("input[name='country']"), function (i, v) {
            arr.forEach((el, j) => {
                let $this = $(v);
                console.log(v.value, decodeURI(el))
                if (v.value == decodeURI(el)) {
                    $this.prop("checked", true);
                }
            });

            let $this = $(v);
            $this
                .parent()
                .parent()
                .parent()
                .find('input[name="region"]')
                .prop("checked", $this.prop("checked"));
        });

        $.each($("input[name='company']"), function (i, v) {
            arr.forEach((el, j) => {
                if (v.value == decodeURI(el)) {
                    $(v).prop("checked", "checked");
                }
            });
        });

        $.each($("input[name='typeOfCompany']"), function (i, v) {
            arr.forEach((el, j) => {
                if (v.value == decodeURI(el)) {
                    $(v).prop("checked", "checked");
                }
            });
        });

        $.each($("input[name='ownership']"), function (i, v) {
            arr.forEach((el, j) => {
                if (v.value == decodeURI(el)) {
                    $(v).prop("checked", "checked");
                }
            });
        });

        $.each($("input[name='overseasPresence']"), function (i, v) {
            arr.forEach((el, j) => {
                if (v.value == decodeURI(el)) {
                    $(v).prop("checked", "checked");
                }
            });
        });

        $.each($("input[name='topics']"), function (i, v) {
            arr.forEach((el, j) => {
                if (v.value == decodeURI(el)) {
                    $(v).prop("checked", "checked");
                }
            });
        });

        self.processFilter();
    }

    resetFilter() {
        const self = this;

        if (
            self.$filterCheckbox !== undefined &&
            self.$filterInput !== undefined &&
            self.$filterMsg !== undefined &&
            self.$filterBtnCountry !== undefined &&
            self.$filterBtnCompany !== undefined &&
            self.$filterBtnTypeOfCompany !== undefined &&
            self.$filterBtnOwnership !== undefined &&
            self.$filterBtnTopics !== undefined &&
            self.$filterBtnOverseasPresence !== undefined
        ) {
            self.$filterCheckbox.prop("checked", false);
            self.$filterInput.val("");

            self.$filterMsg.html("");
            self.$filterBtnCountry.text("");
            self.$filterBtnCompany.text("");
            self.$filterBtnTypeOfCompany.text("");
            self.$filterBtnOwnership.text("");
            self.$filterBtnTopics.text("");
            self.$filterBtnOverseasPresence.text("");
        }

        self.enableCompany();
        self.enableOthers();

        $(".data-results-number").text(0);

        $(".data-results-filters").html("");

        $(".download-results-btn").attr(
            "href",
            `https://docs.google.com/spreadsheets/d/${googleSheets.urlID}/gviz/tq?tqx=out:csv&gid=1003963993&tq=select%20*`
        );

        $(".filter .form-item").removeAttr("style");
        $(".filter__buttons .-filter").removeClass("-expand");

        $(".explore-map").removeClass("-expand");
        $(".toaster__wrap").removeClass("-expand");

        $(".filter__buttons .-checkbox").removeClass("-disabled");
        $('.filter__buttons .-checkbox input[type="checkbox"]').attr(
            "disabled",
            false
        );

        $('.filter__buttons .-toggle input[type="checkbox"]').prop(
            "checked",
            false
        );

        if (
            window.location.hash.indexOf("data") > -1 ||
            window.location.hash.indexOf("map") > -1
        ) {
            self.selectedFilter = [];
            self.processFilter();
        }
    }

    processFilter() {
        const self = this;

        self.selectedObjects = {
            country: [],
            company: [],
            overseasPresence: [],
            typeOfCompany: [],
            ownership: [],
        };

        // * self.isHighlighted = false;
        self.selectedCompany = [];
        self.selectedCountry = [];
        self.selectedType = [];
        self.selectedOwnership = [];
        self.selectedOverseasPresence = [];
        self.selectedTopics = [];

        self.displayCompanies = [];
        self.paramsLength = [];

        // * Resetting Visual
        $(".data-results-number").text("0");

        self.companyArray.forEach((el, i) => {
            el.paramsLength = [];
            el.filter.country = false;
            el.filter.typeOfCompany = false;
            el.filter.ownership = false;
            el.filter.overseasPresence = false;
        });

        // * Store selected checkboxes
        self.dataResultsFiltersArray = []; //reset the array

        $.each($("input[name='ourHighlights']:checked"), function () {
            self.selectedFilter.push(this.value);
        });

        var allCountriesInRegionFixed = {};
        var allCountriesInRegion = {};
        $.each($("input[name='region']:checked"), function () {
            self.dataResultsFiltersArray.push(this.value.slice(3));
            // Do not add country tags if the country filters in a region are included
            var countriesInRegion = this.parentNode.getElementsByTagName(
                "UL"
            )[0]
                ? this.parentNode.getElementsByTagName("UL")[0].children
                : [];
            allCountriesInRegion[this.value.slice(3)] = [];
            allCountriesInRegionFixed[this.value.slice(3)] = [];
            for (var i = 0; i < countriesInRegion.length; i++) {
                allCountriesInRegion[this.value.slice(3)].push(
                    countriesInRegion[i]
                        .getElementsByTagName("LABEL")[0]
                        .getElementsByTagName("SPAN")[0].innerHTML
                );
                allCountriesInRegionFixed[this.value.slice(3)].push(
                    countriesInRegion[i]
                        .getElementsByTagName("LABEL")[0]
                        .getElementsByTagName("SPAN")[0].innerHTML
                );
            }
        });

        $.each($("input[name='country']:checked"), function () {
            self.selectedCountry.push(this.value.slice(3));
            self.selectedFilter.push(this.value);
            self.dataResultsFiltersArray.push(this.value.slice(3));
            // Do not add country tags if the country filters in a region are included
            for (var region in allCountriesInRegion) {
                var countryIndex = allCountriesInRegion[region].indexOf(
                    this.value.slice(3)
                );
                if (countryIndex > -1) {
                    allCountriesInRegion[region].splice(countryIndex, 1);
                }
                if (allCountriesInRegion[region].length === 0) {
                    // this means all countries in the region are ticked/checked
                    for (
                        var i = 0;
                        i < allCountriesInRegionFixed[region].length;
                        i++
                    ) {
                        var dataResultsCountryIndex =
                            self.dataResultsFiltersArray.indexOf(
                                allCountriesInRegionFixed[region][i]
                            );
                        if (dataResultsCountryIndex > -1) {
                            self.dataResultsFiltersArray.splice(
                                dataResultsCountryIndex,
                                1
                            );
                        }
                    }
                }
            }
        });

        $.each($("input[name='company']:checked"), function () {
            self.selectedCompany.push(this.value.slice(3));
            self.selectedFilter.push(this.value);
            self.dataResultsFiltersArray.push(this.value.slice(3));
        });

        $.each($("input[name='typeOfCompany']:checked"), function () {
            self.selectedType.push(this.value.slice(3));
            self.selectedFilter.push(this.value);
            self.dataResultsFiltersArray.push(this.value.slice(3));
        });

        $.each($("input[name='ownership']:checked"), function () {
            self.selectedOwnership.push(this.value.slice(3));
            self.selectedFilter.push(this.value);
            self.dataResultsFiltersArray.push(this.value.slice(3));
        });

        $.each($("input[name='overseasPresence']:checked"), function () {
            self.selectedOverseasPresence.push(this.value.slice(3));
            self.selectedFilter.push(this.value);
            self.dataResultsFiltersArray.push(this.value.slice(3));
        });

        $.each($("input[name='topics']:checked"), function () {
            self.selectedTopics.push(this.value.slice(3));
            self.selectedFilter.push(this.value);
            self.dataResultsFiltersArray.push(this.value.slice(3));
        });

        // if (
        //     self.selectedCountry.length > 0 ||
        //     self.selectedCompany.length > 0 ||
        //     self.selectedType.length > 0 ||
        //     self.selectedOwnership.length > 0 ||
        //     self.selectedOverseasPresence.length > 0 ||
        //     self.selectedTopics.length > 0
        // ) {
        //     // Hide columns
        //     $('.filter__buttons .-checkbox').hide();
        // } else {
        //     // Show columns if no filter selected
        //     $('.filter__buttons .-checkbox').show();
        // }
        // * Check how many filter columns selected
        self.checkFilterColumns();
    }

    enableOthers() {
        $("input[name='country']").each((i, v) => {
            $(v).attr("disabled", false);
        });

        $("input[name='typeOfCompany']").each((i, v) => {
            $(v).attr("disabled", false);
        });

        $("input[name='ownership']").each((i, v) => {
            $(v).attr("disabled", false);
        });

        $("input[name='overseasPresence']").each((i, v) => {
            $(v).attr("disabled", false);
        });

        $("input[name='topics']").each((i, v) => {
            $(v).attr("disabled", false);
        });

        $(".filter__selection.-country").removeClass("-disabled");
        $(".filter__selection.-type-of-company").removeClass("-disabled");
        $(".filter__selection.-ownership").removeClass("-disabled");
        $(".filter__selection.-overseasPresence").removeClass("-disabled");
        $(".filter__selection.-topics").removeClass("-disabled");
    }

    disableOthers() {
        $("input[name='country']").each((i, v) => {
            $(v).attr("disabled", true);
        });

        $("input[name='typeOfCompany']").each((i, v) => {
            $(v).attr("disabled", true);
        });

        $("input[name='ownership']").each((i, v) => {
            $(v).attr("disabled", true);
        });

        $("input[name='overseasPresence']").each((i, v) => {
            $(v).attr("disabled", true);
        });

        $("input[name='topics']").each((i, v) => {
            $(v).attr("disabled", true);
        });

        $(".filter__selection.-country").addClass("-disabled");
        $(".filter__selection.-type-of-company").addClass("-disabled");
        $(".filter__selection.-ownership").addClass("-disabled");
        $(".filter__selection.-overseasPresence").addClass("-disabled");
        $(".filter__selection.-topics").addClass("-disabled");
    }

    enableCompany() {
        $("input[name='company']").each((i, v) => {
            $(v).attr("disabled", false);
        });

        $(".filter__selection.-company").removeClass("-disabled");
    }

    disableCompany(param) {
        $(`.filter__selection.-company .-checkbox`)
            .addClass("-disabled")
            .find('input[type="checkbox"]')
            .prop("disabled", true);

        $(`#${param}-company`)
            .prop("checked", true)
            .trigger("change")
            .parent()
            .removeClass("-disabled")
            .addClass("-selected");

        $(".filter__selection.-company").addClass("-disabled");
    }

    setMarkers(markersArr) {
        const self = this;

        self.markersArr = markersArr;
    }
}
